// Template276: Pekín - Aeropuertos (AeropuertosPekin.jsx)
// Cabecera, intro, bloques aeropuertos (titulo, body, ul), caja amarilla consejo.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template276 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const tipConsejo = page?.texts?.[2]?.content;

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const logoImage = getCanvasImageUrl("logo");
	const aeropuertos = Array.isArray(page?.data?.aeropuertos)
		? page.data.aeropuertos
		: [];
	const actualHeaderColor = headerBackgroundColor || "#8c1d18";

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const sticker = getImageSrc("airport-sticker");

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 66,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: 2.5,
					flex: 1,
					overflow: "auto",
					position: "relative",
				}}
			>
				{intro && (
					<Box component="p" sx={{ ...estiloP, marginBottom: 1.75 }}>
						{intro}
					</Box>
				)}

				{aeropuertos.map((a, idx) => (
					<Box
						key={a.titulo}
						data-block-id={`text-${idx + 2}`}
						sx={{
							backgroundColor: "#fff",
							borderRadius: "12px",
							padding: "12px 14px",
							border: "2px solid #e8e8e8",
							marginBottom: 1.75,
						}}
					>
						{a.titulo && (
							<Box component="h3" sx={{ ...estiloH3, marginBottom: 1 }}>
								{a.titulo}
							</Box>
						)}
						{a.body && (
							<Box
								component="p"
								sx={{ ...estiloP, marginBottom: 1.25, fontSize: 13 }}
							>
								{a.body}
							</Box>
						)}
						{a.itemsHtml && (
							<Box
								component="ul"
								sx={{
									paddingLeft: 2.5,
									margin: 0,
									lineHeight: 1.6,
									fontSize: 13,
									color: "#444",
								}}
								dangerouslySetInnerHTML={{ __html: a.itemsHtml }}
							/>
						)}
					</Box>
				))}

				{tipConsejo && (
					<Box
						data-block-id="text-consejo"
						sx={{
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "12px",
							padding: "10px 14px",
							fontSize: 13,
							color: "#444",
							position: "relative",
						}}
					>
						<Box
							component="p"
							sx={{ ...estiloP, marginBottom: 1.25, fontSize: 13 }}
						>
							{tipConsejo}
						</Box>
						{sticker && (
							<img
								src={sticker}
								alt=""
								style={{
									width: 95,
									position: "absolute",
									bottom: isSmallScreen ? -80 : -80,
									right: 0,
								}}
							/>
						)}
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template276.thumbnail = "/images/template-1.png";
export default Template276;
